import { Pipe, PipeTransform } from "@angular/core";
import { GlobalService } from "../../services/global.service";


@Pipe({
  name: "translation",
  pure: false
})


export class TranslationPipe implements PipeTransform {

  private key: any = {
    'connect': {
      'fr': 'Connexion',
      'de': 'Verbindung',
      'en': 'Login',
      'it': 'Connessione'
    },
    'accessBO': {
      'fr': 'Merci de saisir vos identifiants',
      'de': 'Vielen Dank für die Eingabe Ihres Benutzernamens',
      'en': 'Please enter your email and password',
      'it': 'Grazie per aver inserito il tuo nome utente'
    },
    'email': {
      'fr': 'Email',
      'de': 'Email',
      'en': 'Email',
      'it': 'Email'
    }, 'password': {
      'fr': 'Mot de passe',
      'de': 'Passwort',
      'en': 'Password',
      'it': "Parola d'ordine"
    }, 'connectUser': {
      'fr': 'Se connecter',
      'de': 'Einloggen',
      'en': 'Log in',
      'it': 'Per accedere'
    },
    'needHelp': {
      'fr': "Besoin d'aide ?",
      'de': 'Brauchen Sie Hilfe ?',
      'en': 'Need help?',
      'it': 'Ho bisogno di aiuto ?'
    },
    'periodManager': {
      'fr': 'Gestion des dates',
      'de': '',
      'en': '',
      'it': ''
    }, 'contentManager': {
      'fr': 'Gestion des interactions',
      'de': '',
      'en': '',
      'it': ''
    },
    'itemList': {
      'fr': 'Élément',
      'de': '',
      'en': '',
      'it': ''
    },

    'savContact': {
      'fr': 'Envoyez-nous un message sur',
      'de': 'Senden Sie uns eine Nachricht an',
      'en': 'Send us a message on',
      'it': 'Inviaci un messaggio su'
    }, 'global': {
      'fr': 'Général',
      'de': 'Global',
      'en': 'Global',
      'it': 'Globale'
    }, 'noDeviceSelected': {
      'fr': 'Aucun appareil sélectionné',
      'de': 'Kein Gerät ausgewählt',
      'en': 'No device selected',
      'it': 'Nessun dispositivo selezionato'
    }, "textDeviceSelection": {
      "fr": "Veuillez selectionner un appareil pour accéder aux options",
      "de": "",
      "en": "",
      "it": ""
    }, 'applyToAll': {
      'fr': 'Appliquer ces options a tout le groupe',
      'de': 'Wenden Sie diese Einstellungen auf die Gruppe an',
      'en': 'Apply these settings to group',
      'it': 'Applica queste impostazioni al gruppo'
    }, 'applyToDevice': {
      'fr': 'Appliquer cette configuration à d\'autres bornes',
      'de': '',
      'en': '',
      'it': ''
    }

    , 'globalParameters': {
      'fr': 'Paramètres généraux',
      'de': 'Allgemeine Einstellungen',
      'en': 'Global Settings',
      'it': 'Impostazioni generali'
    },
    "parameterDescription": {
      "fr": "Paramétrez l'écran de veille, le texte d'accueil, ...",
      "de": "Konfigurieren Sie den Bildschirmschoner, Begrüßungstext, ...",
      "en": "Configure the screen saver, welcome text, ...",
      "it": "Configura lo screen saver, il testo di benvenuto, ..."
    },
    "background": {
      "fr": "Fond d'écran",
      "de": "Hintergrund",
      "en": "Background image",
      "it": "Sfondo"
    },
    "background2": {
      "fr": "Arrière-plan",
      "de": "Hintergrund",
      "en": "Background image",
      "it": "Sfondo"
    },
    "backgroundWheel": {
      "fr": "Fond d'écran de la roue",
      "de": "Hintergrund",
      "en": "Background image",
      "it": "Sfondo"
    },
    "backgroundDescription": {
      "fr": "Importer des images ou vidéos (.jpg, .mp4)",
      "de": "Bilder oder Videos importieren (.jpg, .mp4)",
      "en": "Import images or videos (.jpg, .mp4)",
      "it": "Importa immagini o video (.jpg, .mp4)"
    },
    "activate": {
      "fr": "Activer",
      "de": "Aktivieren",
      "en": "Activate",
      "it": "Attivare"
    },

    "duplicate"
      : {
      "fr": "Dupliquer",
      "de": "",
      "en": "",
      "it": ""
    },
    "delete": {
      "fr": "Suppression",
      "de": "Entfernen",
      "en": "Delete",
      "it": "Rimuovere"
    },

    "repairMedia": {
      "fr": "Réparer",
      "de": "",
      "en": "",
      "it": ""
    },

    "repairCurrentFolder": {
      "fr": "Réparer tout les éléments du dossier",
      "de": "",
      "en": "",
      "it": ""
    },
    "localist": {
      "fr": "Activer l'autocomplétion",
      "de": "",
      "en": "",
      "it": ""
    },
    "allowNewListEntry": {
      "fr": "Autoriser l'ajout de nouveaux éléments localement",
      "de": "",
      "en": "",
      "it": ""
    },
    "allowDeleteListEntry": {
      "fr": "Supprimer l'élément selectionner des données locales",
      "de": "",
      "en": "",
      "it": ""
    },
    'saveLocally': {
      "fr": "Ajouter la valeur dans la liste locale",
      "de": "",
      "en": "",
      "it": ""
    },

    'skipNextQuestion': {
      "fr": "Passer la question suivante",
      "de": "",
      "en": "",
      "it": ""
    },
    'useAsEmail': {
      "fr": "Utiliser la valeur en tant que destinataire de l'email",
      "de": "",
      "en": "",
      "it": ""
    }, 'addToEmail': {
      "fr": "Ajouter au contenu de l'email",
      "de": "",
      "en": "",
      "it": ""
    },
    "importBackground": {
      "fr": "Importer une image d'arrière-plan",
      "de": "Hintergrundbild importieren",
      "en": "Import a background image",
      "it": "Importa un'immagine di sfondo"
    }, "activateSlideshow": {
      "fr": "Activer le diaporama",
      "de": "Aktiviere die Diashow",
      "en": "Activate slideshow",
      "it": "Attiva la presentazione"
    },
    "activateActionBasedBackground": {
      "fr": "Activer l'arrière-plan par action",
      "de": "",
      "en": "",
      "it": ""
    },

    "selectConfigActionType": {
      "fr": "Selectionner le type de déclencheur",
      "de": "",
      "en": "",
      "it": ""
    },
    "welcomeText": {
      "fr": "Texte de bienvenue",
      "de": "Begrüßungstext",
      "en": "Welcome text",
      "it": "Testo di benvenuto"
    }, "screensaverText": {
      "fr": "Texte affiché sur l'écran de veille",
      "de": "Auf dem Bildschirmschoner angezeigter Text",
      "en": "Text displayed on the screen saver",
      "it": "Testo visualizzato sullo screen saver"
    }, "changeText": {
      "fr": "Modifier le texte",
      "de": "Text bearbeiten",
      "en": "Edit text",
      "it": "Modifica il testo"
    },
    "changeHomeText": {
      "fr": "Modifier le texte d'accueil",
      "de": "Text bearbeiten",
      "en": "Edit text",
      "it": "Modifica il testo"
    },
    "activateText": {
      "fr": "Activer le texte",
      "de": "Text aktivieren",
      "en": "Show text",
      "it": "Attiva testo"
    }, "activateTextBackground": {
      "fr": "Activer un arrière-plan pour le texte",
      "de": "Aktiviere einen Hintergrund für den Text",
      "en": "Show text background",
      "it": "Attiva uno sfondo per il testo"
    }, "textBackgroundColor": {
      "fr": "Couleur de l'arrière- plan du texte",
      "de": "Texthintergrundfarbe",
      "en": "Background text color",
      "it": "Colore di sfondo del testo"
    },

    'welcomeTextColor': {
      "fr": "Couleur du texte de bienvenue",
      "de": "Texthintergrundfarbe",
      "en": "Background text color",
      "it": "Colore di sfondo del testo"
    },
    "changeColor": {
      "fr": "Modifier la couleur",
      "de": "Farbe ändern",
      "en": "Edit color",
      "it": "Cambia colore"
    }, "activateAnimation": {
      "fr": "Activer l'animation",
      "de": "Animation aktivieren",
      "en": "Show touch animation",
      "it": "Attiva l'animazione"
    }, "activateDate": {
      "fr": "Activer la date",
      "de": "Datum aktivieren",
      "en": "Show date/time",
      "it": "Data di attivazione"
    }, "textColor": {
      "fr": "Couleur du texte",
      "de": "Textfarbe",
      "en": "Text color",
      "it": "Colore del testo"
    }, "buttonColor": {
      "fr": "Couleur des boutons",
      "de": "Knopffarbe",
      "en": "Buttons color",
      "it": "Colore pulsante"
    }, "inactivity": {
      "fr": "Délai d'inactivité",
      "de": "Timeout durch Inaktivität",
      "en": "Idle time",
      "it": "Timeout di inattività"
    },
    "inactivityDescription": {
      "fr": "Durée (en sec) avant le lancement de l'écran de veille",
      "de": "Dauer (in Sekunden), bevor der Bildschirmschoner gestartet wird",
      "en": "Delay (sec.) before idle",
      "it": "Durata (in secondi) prima dell'avvio dello screen saver"
    }, "seconds": {
      "fr": "secondes",
      "de": "Sekunden",
      "en": "seconds",
      "it": "secondi"
    }, "changeDelay": {
      "fr": "Modifier la durée",
      "de": "Ändern Sie die Dauer",
      "en": "Change delay time",
      "it": "Cambia la durata"
    },
    "changeDelayInac": {
      "fr": "Modifier la durée d'inactivité",
      "de": "",
      "en": "",
      "it": ""
    },
    "adminPassword": {
      "fr": "Mot de passe administrateur",
      "de": "Administrator-Passwort",
      "en": "Admin password",
      "it": "Password amministratore"
    }, "configDevice": {
      "fr": "Accès à la configuration de votre appareil",
      "de": "Geräteeinstellungen",
      "en": "Device settings",
      "it": "Impostazioni del dispositivo"
    }, "changePassword": {
      "fr": "Modifier le mot de passe",
      "de": "Kennwort ändern",
      "en": "Change password",
      "it": "Cambia la password"
    },
    "wakeUpManager": {
      "fr": "Gestion de l'extinction",
      "de": "",
      "en": "",
      "it": ""
    },
    "wakeUpExplain": {
      "fr": "Gestion de l'allumage et de l'extinction automatique de l'écran",
      "de": "",
      "en": "",
      "it": ""
    },
    "enableWakeup":
    {
      "fr": "Activer l'extinction / l'allumage automatique",
      "de": "",
      "en": "",
      "it": ""
    },

    "mediaContent": {
      "fr": "Contenus Média",
      "de": "Inhaltsmedien",
      "en": "Medias contents",
      "it": "Contenuti multimediali"
    }, "webPage": {
      "fr": "Pages Web",
      "de": "Webseiten",
      "en": "Web pages",
      "it": "pagine web"
    }, "quiz": {
      "fr": "Questionnaire",
      "de": "Umfrage",
      "en": "Form",
      "it": "Sondaggio"
    }, "lottery": {
      "fr": "Loterie",
      "de": "Loterie",
      "en": "Lottery",
      "it": "Lotteria"
    }, "data": {
      "fr": "Données",
      "de": "Daten",
      "en": "Datas",
      "it": "Dati"
    }, "selfie": {
      "fr": "Selfie",
      "de": "Selfie",
      "en": "Selfie",
      "it": "Selfie"
    }, "home": {
      "fr": "Accueil",
      "de": "Zuhause",
      "en": "Home",
      "it": "accoglienza"
    }, "mapcontent": {
      "fr": "Contenu Carte",
      "de": "",
      "en": "",
      "it": ""
    },
    "categoryName": {
      "fr": "Nom de catégorie",
      "de": "",
      "en": "",
      "it": ""
    },
    "annexoption": {
      "fr": "Option annexe",
      "de": "",
      "en": "",
      "it": ""
    },

    "randomizeQuestion": {
      "fr": "Ordre aléatoire des questions",
      "de": "",
      "en": "",
      "it": ""
    },
    "enableEmail": {
      "fr": "Activer l'envoi d'email",
      "de": "",
      "en": "",
      "it": ""
    },
    'emailAlreadyUsed': {
      "fr": "Cet email est déjà utilisé.",
      "de": "",
      "en": "",
      "it": ""
    },
    'tooManyEmailSaved': {
      "fr": "Le nombre maximal d'adresse email a été atteint.",
      "de": "",
      "en": "",
      "it": ""
    }
    ,
    "buttonIcon": {
      "fr": "Icône du bouton",
      "de": "Schaltflächensymbol",
      "en": "Button icon",
      "it": "Schaltflächensymbol"
    }, "backgroundImage": {
      "fr": "Image d'arrière-plan",
      "de": "Hintergrundbild",
      "en": "Background image",
      "it": "Immagine di sfondo"
    }, "mainLogo": {
      "fr": "Logo principal",
      "de": "Hauptlogo",
      "en": "Main logo",
      "it": "Logo principale"
    }, "buttonDesign": {
      "fr": "Design bouton média",
      "de": "Schaltflächen-Aspekt",
      "en": "Button aspect",
      "it": "Aspetto pulsante"
    }, "full": {
      "fr": "Complet",
      "de": "Komplett",
      "en": "Full",
      "it": "Completa"
    },
    "thumbnailSize": {
      "fr": "Taille de la vignette",
      "de": "Thumbnail Größe",
      "en": "Thumb size",
      "it": "Dimensione miniatura"
    }, "minimal": {
      "fr": "Minimal",
      "de": "Minimal",
      "en": "Minimal",
      "it": "Minimo"
    },
    "image": {
      "fr": "Image",
      "de": "Bild",
      "en": "Photo",
      "it": "Immagine"
    }, "content": {
      "fr": "Contenu",
      "de": "Inhalt",
      "en": "Content",
      "it": "Soddisfare"
    }
    , "noPreview": {
      "fr": "Aucun aperçu",
      "de": "",
      "en": "",
      "it": ""
    },
    "disable": {
      "fr": "Désactiver",
      "de": "",
      "en": "",
      "it": ""
    },
    "lock": {
      "fr": "Verrouiller",
      "de": "",
      "en": "",
      "it": ""
    },
    "unlock": {
      "fr": "Déverrouiller",
      "de": "",
      "en": "",
      "it": ""
    }, "addThumbnail": {
      "fr": "Ajouter une vignette",
      "de": "",
      "en": "",
      "it": ""
    }, "deleteThumbnail": {
      "fr": "Supprimer une vignette",
      "de": "",
      "en": "",
      "it": ""
    }, "manageTag": {
      "fr": " Gérer les tags",
      "de": "",
      "en": "",
      "it": ""
    }, "moveTo": {
      "fr": "Déplacer vers",
      "de": "",
      "en": "",
      "it": ""
    }, "rename": {
      "fr": "Renommer",
      "de": "",
      "en": "",
      "it": ""
    }, "noContent": {
      "fr": "Aucun contenu à afficher",
      "de": "",
      "en": "",
      "it": ""
    }, "addItem": {
      "fr": "Ajouter un élément",
      "de": "",
      "en": "",
      "it": ""
    },
    "addClientFile": {
      "fr": "Ajouter une configuration client",
      "de": "",
      "en": "",
      "it": ""
    }
    , "addFile": {
      "fr": "Ajouter un fichier",
      "de": "",
      "en": "",
      "it": ""
    }, "addFolder": {
      "fr": "Ajouter un dossier",
      "de": "",
      "en": "",
      "it": ""
    },
    "import3DMap": {
      "fr": "Importer carte 3D",
      "de": "",
      "en": "",
      "it": ""
    },"importWeb": {
      "fr": "Importer une page web",
      "de": "",
      "en": "",
      "it": ""
    }, "importQuiz": {
      "fr": "Importer un questionnaire",
      "de": "",
      "en": "",
      "it": ""
    }, "importLottery": {
      "fr": "Importer une Loterie",
      "de": "",
      "en": "",
      "it": ""
    }, "createSubFolder": {
      "fr": "Créer un sous-dossier",
      "de": "",
      "en": "",
      "it": ""
    },
    "open3DMap": {
      "fr": "Ouvrir le fichier 3D",
      "de": "",
      "en": "",
      "it": ""
    },

    "createFloor": {
      "fr": "Créer un étage",
      "de": "",
      "en": "",
      "it": ""
    },
    "kioskModuleTitle": {
      "fr": "Personnalisation du module 'Kiosk Web'",
      "de": "",
      "en": "",
      "it": ""
    }, "kioskModuleDescription": {
      "fr": "Configurez les pages web accessibles depuis votre appareil",
      "de": "",
      "en": "",
      "it": ""
    }, "addWebPage": {
      "fr": "Ajouter une page web",
      "de": "",
      "en": "",
      "it": ""
    }, "lockDomaine": {
      "fr": "Verrouillage sur le nom de domaine",
      "de": "",
      "en": "",
      "it": ""
    }, "deleteCookies": {
      "fr": "Suppression des cookies",
      "de": "",
      "en": "",
      "it": ""
    }, "missingLabel": {
      "fr": "Label manquant",
      "de": "",
      "en": "",
      "it": ""
    }, "missingURL": {
      "fr": "URL manquante",
      "de": "",
      "en": "",
      "it": ""
    }, "customQuizTitle": {
      "fr": "Personnalisation du module 'Quiz'",
      "de": "",
      "en": "",
      "it": ""
    },
    "customLotteryTitle": {
      "fr": "Personnalisation du module 'Loterie'",
      "de": "",
      "en": "",
      "it": ""
    }
    , "manageQuiz": {
      "fr": "Gérez vos questionnaires",
      "de": "",
      "en": "",
      "it": ""
    }, "manageLottery": {
      "fr": "Gérez vos loteries",
      "de": "",
      "en": "",
      "it": ""
    }, "newQuiz": {
      "fr": "Nouveau quiz",
      "de": "",
      "en": "",
      "it": ""
    }, "newLottery": {
      "fr": "Nouvelle loterie",
      "de": "",
      "en": "",
      "it": ""
    }, "enableRules": {
      "fr": "Activer le règlement",
      "de": "",
      "en": "",
      "it": ""
    }, "importRules": {
      "fr": "Importer le règlement (.jpg)",
      "de": "",
      "en": "",
      "it": ""
    }, "edit": {
      "fr": "Editer",
      "de": "",
      "en": "",
      "it": ""
    }, "thanksText": {
      "fr": "Texte de remerciement",
      "de": "",
      "en": "",
      "it": ""
    }, "scoreManagement": {
      "fr": "GESTION DU SCORE",
      "de": "",
      "en": "",
      "it": ""
    }, "activeScore": {
      "fr": "Activer le score",
      "de": "",
      "en": "",
      "it": ""
    }, "scorePointDescription": {
      "fr": "Nombre de points attribués pour chaque question",
      "de": "",
      "en": "",
      "it": ""
    }, "addMsg": {
      "fr": "Ajouter un message",
      "de": "",
      "en": "",
      "it": ""
    },
    "msg": {
      "fr": "Message",
      "de": "",
      "en": "",
      "it": ""
    }, "text": {
      "fr": "Texte",
      "de": "",
      "en": "",
      "it": ""
    },
    "addQuestion": {
      "fr": "Ajouter une question",
      "de": "",
      "en": "",
      "it": ""
    }, "addQuestions": {
      "fr": "Ajouter des questions",
      "de": "",
      "en": "",
      "it": ""
    },
    "addQuestionSub": {
      "fr": "Ajoutez, personnalisez et réarrangez l’ordre.",
      "de": "",
      "en": "",
      "it": ""
    }, "addQuestionExplanation": {
      "fr": "Chaque question ajoutée se place automatiquement à la fin du questionnaire.",
      "de": "",
      "en": "",
      "it": ""
    }
    , "question": {
      "fr": "Question",
      "de": "",
      "en": "",
      "it": ""
    }, "condition": {
      "fr": "Condition",
      "de": "",
      "en": "",
      "it": ""
    }, "none": {
      "fr": "Aucune",
      "de": "",
      "en": "",
      "it": ""
    }, "reqField": {
      "fr": "Champ requis",
      "de": "",
      "en": "",
      "it": ""
    },
    "endQuiz": {
      "fr": "Terminer le questionnaire après cette question",
      "de": "",
      "en": "",
      "it": ""
    },
    'endQuizResp': {
      "fr": "Terminer le questionnaire après cette réponse",
      "de": "",
      "en": "",
      "it": ""
    },
    'responseAdditionnalElement': {
      "fr": "Afficher un message après cette réponse",
      "de": "",
      "en": "",
      "it": ""
    },

    "verifType": {
      "fr": "Type de vérification",
      "de": "",
      "en": "",
      "it": ""
    }, "phoneNumber": {
      "fr": "Téléphone",
      "de": "",
      "en": "",
      "it": ""
    }, "zipCode": {
      "fr": "Code postal",
      "de": "",
      "en": "",
      "it": ""
    },
    "date": {
      "fr": "Date",
      "de": "",
      "en": "",
      "it": "",
    },
    "correctAnswer": {
      "fr": "Bonne réponse",
      "de": "",
      "en": "",
      "it": ""
    },
    "correctAnswerMessage": {
      "fr": "Message si réponse correcte",
      "de": "",
      "en": "",
      "it": ""
    }, "wrongAnswerMessage": {
      "fr": "Message si réponse erronnée",
      "de": "",
      "en": "",
      "it": ""
    }, "media": {
      "fr": "Média",
      "de": "",
      "en": "",
      "it": ""
    }, "multiResp": {
      "fr": "Plusieurs réponses possibles",
      "de": "",
      "en": "",
      "it": ""
    }, "addResp": {
      "fr": "Ajouter une réponse",
      "de": "",
      "en": "",
      "it": ""
    }, "questionTitle": {
      "fr": "Intitulé de la question",
      "de": "",
      "en": "",
      "it": ""
    }, "resp": {
      "fr": "Réponse",
      "de": "",
      "en": "",
      "it": ""
    },
    "reqResp": {
      "fr": "Réponse obligatoire",
      "de": "",
      "en": "",
      "it": ""
    },
    "endTextQuestion": {
      "fr": "Afficher un texte à la fin de la question",
      "de": "",
      "en": "",
      "it": ""
    },
    "sendEmailToResponse": {
      "fr": "Envoyer un e-mail à l’adresse de la réponse sélectionnée (entre [ ])",
      "de": "",
      "en": "",
      "it": ""
    }
    ,
    "endTextQuestionLabel": {
      "fr": "",
      "de": "",
      "en": "",
      "it": ""
    },
    "previewQuestion": {
      "fr": "Aperçu des questions",
      "de": "",
      "en": "",
      "it": ""
    },
    "textfield": {
      "fr": "Text libre",
      "de": "",
      "en": "",
      "it": ""
    },
    "textField": {
      "fr": "Champ texte libre",
      "de": "",
      "en": "",
      "it": ""
    }, "qcm": {
      "fr": "QCM",
      "de": "",
      "en": "",
      "it": ""
    }, "signature": {
      "fr": "Signature",
      "de": "",
      "en": "",
      "it": ""

    }, "list": {
      "fr": "Liste",
      "de": "",
      "en": "",
      "it": ""
    }, "backgroundColor": {
      "fr": "Couleur arrière plan",
      "de": "",
      "en": "",
      "it": ""
    }, "fontColor": {
      "fr": "Couleur police",
      "de": "",
      "en": "",
      "it": ""
    },
    "fontColorButton": {
      "fr": "Couleur police boutons",
      "de": "",
      "en": "",
      "it": ""
    },
    "keyboardPosition": {

      "fr": "Position clavier",
      "de": "",
      "en": "",
      "it": ""
    }, "startText": {
      "fr": "Texte de début",
      "de": "",
      "en": "",
      "it": ""
    },
    "sendToWinner": {
      "fr": "Envoyer l'email aux gagnants uniquement",
      "de": "",
      "en": "",
      "it": ""
    },
    "emailObject": {
      "fr": "Sujet de l'email",
      "de": "",
      "en": "",
      "it": ""
    }, "emailContent": {
      "fr": "Contenu de l'email",
      "de": "",
      "en": "",
      "it": ""
    },

    "oneTry": {
      "fr": "Limiter à une seul participation par email",
      "de": "",
      "en": "",
      "it": ""
    }, "confirm": {
      "fr": "Confirmation",
      "de": "",
      "en": "",
      "it": ""
    }, "config": {
      "fr": " Configuration",
      "de": "",
      "en": "",
      "it": ""
    }, "sendEmail": {
      "fr": "Envoi d'un email de confirmation au participant",
      "de": "",
      "en": "",
      "it": ""
    }, "activateQuiz": {
      "fr": "Activer le questionnaire",
      "de": "",
      "en": "",
      "it": ""
    }, "game": {
      "fr": "Jeu",
      "de": "",
      "en": "",
      "it": ""
    }, "activateGame": {
      "fr": "Activer le jeu",
      "de": "",
      "en": "",
      "it": ""
    },
    "gamePeriode": {
      "fr": "Période de jeu",
      "de": "",
      "en": "",
      "it": ""
    }, "startDate": {
      "fr": "Date de début",
      "de": "",
      "en": "",
      "it": ""
    }, "endDate": {
      "fr": "Date de fin",
      "de": "",
      "en": "",
      "it": ""
    }, "startTime": {
      "fr": "Heure de début",
      "de": "",
      "en": "",
      "it": ""
    }, "endTime": {
      "fr": "Heure de fin",
      "de": "",
      "en": "",
      "it": ""
    }, "prizeManagement": {
      "fr": "Gestion des lots",
      "de": "",
      "en": "",
      "it": ""
    }, "latestUpdate": {
      "fr": "Dernière mise a jour",
      "de": "",
      "en": "",
      "it": ""
    }, "addPrize": {
      "fr": "Ajouter un lot",
      "de": "",
      "en": "",
      "it": ""
    }, "initQuant": {
      "fr": "Stock",
      "de": "",
      "en": "",
      "it": ""
    }, "currentQuant": {
      "fr": "Stock actuel",
      "de": "",
      "en": "",
      "it": ""
    }, "color": {
      "fr": "Couleur",
      "de": "",
      "en": "",
      "it": ""
    }, "noData": {
      "fr": "Aucune donnée disponible",
      "de": "",
      "en": "",
      "it": ""
    }, "loadingData": {
      "fr": "Chargement des données en cours",
      "de": "",
      "en": "",
      "it": ""
    }, "quizName": {
      "fr": "Nom du questionnaire",
      "de": "",
      "en": "",
      "it": ""
    }, "lotteryName": {
      "fr": "Nom de la loterie",
      "de": "",
      "en": "",
      "it": ""
    }, "enterKeyWord": {
      "fr": "Tapez un mot clé",
      "de": "",
      "en": "",
      "it": ""
    }, "exportData": {
      "fr": "Exporter les données",
      "de": "",
      "en": "",
      "it": ""
    },
    "exportAllData": {
      "fr": "Exporter les données de toute les bornes",
      "de": "",
      "en": "",
      "it": ""
    }
    , "deleteData": {
      "fr": "Supprimer les données",
      "de": "",
      "en": "",
      "it": ""
    }, "module": {
      "fr": "Module",
      "de": "",
      "en": "",
      "it": ""
    }, "cancel": {
      "fr": "Annuler",
      "de": "",
      "en": "",
      "it": ""
    }, "close": {
      "fr": "Fermer",
      "de": "",
      "en": "",
      "it": ""
    }, "buttonText": {
      "fr": "Label du bouton",
      "de": "",
      "en": "",
      "it": ""
    },
    "urlText": {
      "fr": "URL de la page",
      "de": "",
      "en": "",
      "it": ""
    }, "prizeName": {
      "fr": "Titre du lot",
      "de": "",
      "en": "",
      "it": ""
    }, "quantityPrize": {
      "fr": "Quantité à distribuer",
      "de": "",
      "en": "",
      "it": ""
    }, "quantity": {
      "fr": "Quantité",
      "de": "",
      "en": "",
      "it": ""
    }, "winningPrizeText": {
      "fr": "Texte à afficher en fin de jeu",
      "de": "",
      "en": "",
      "it": ""
    }, "isWinner": {
      "fr": "Champ gagnant",
      "de": "",
      "en": "",
      "it": ""
    }, "specialPrize": {
      "fr": "Lot spécial",
      "de": "",
      "en": "",
      "it": ""
    }, "import": {
      "fr": "Importer",
      "de": "",
      "en": "",
      "it": ""
    }, "warningFileUpload": {
      "fr": "La taille du fichier n'est pas valide (20Mb pour les images et 2Gb pour les vidéos)",
      "de": "",
      "en": "",
      "it": ""
    }, "add": {
      "fr": "Ajouter",
      "de": "",
      "en": "",
      "it": ""
    }, "warningApplyToAll": {
      "fr": "Voulez vous copier ces éléments dans les toute les bornes du groupe actuel ? (Les données précédents ne pourront être récupéré.)",
      "de": "",
      "en": "",
      "it": ""
    },
    'warningApplyToDevice': {
      "fr": "Voulez vous copier ces éléments dans la borne selectionnée ? (Les données précédents ne pourront être récupéré.)",
      "de": "",
      "en": "",
      "it": ""
    }
    , "warningDeleteStat": {
      "fr": "Voulez vous vraiment supprimer ces données de statistiques ? (Les données ne pourront être récupéré.)",
      "de": "",
      "en": "",
      "it": ""
    },
    "warningDeleteLottery": {
      "fr": "Voulez vous vraiment supprimer cette configuration de loterie ?",
      "de": "",
      "en": "",
      "it": ""
    }, "warningDeleteActiveLottery": {
      "fr": "Impossible de supprimer la configuration de loterie active.",
      "de": "",
      "en": "",
      "it": ""
    },

    "warningCannotDeleteBackground": {
      "fr": "Impossible de supprimer l\'arrière-plan actif",
      "de": "",
      "en": "",
      "it": ""
    }, "warningLimitBackground": {
      "fr": "La limite d'image a été atteinte, veuiller supprimer des images avant.",
      "de": "",
      "en": "",
      "it": ""
    }, "colorTextDisplay": {
      "fr": "Couleur d'affichage du texte",
      "de": "",
      "en": "",
      "it": ""
    }, "colorBackgroundDisplay": {
      "fr": "Couleur d'affichage de l'arriere-plan",
      "de": "",
      "en": "",
      "it": ""
    }, "colorWelcomeTextDisplay": {
      "fr": "Couleur d'affichage du texte de bienvenue",
      "de": "",
      "en": "",
      "it": ""
    }, "confirmDeleteKiosk": {
      "fr": "Voulez vraiment supprimer cette page web ? (Cette action est irrévocable)",
      "de": "",
      "en": "",
      "it": ""
    }, "confirmOperation": {
      "fr": "Cette opération est irréversible, voulez-vous continuer ?",
      "de": "",
      "en": "",
      "it": ""
    }, "warningDeleteData": {
      "fr": "Êtes-vous sûr de vouloir supprimer ces données ? (Cette action est irréversible)",
      "de": "",
      "en": "",
      "it": ""
    }, "changePrize": {
      "fr": "Modifier un lot",
      "de": "",
      "en": "",
      "it": ""
    }, "warningGameUpdate": {
      "fr": "Un jeu est en cours, tout modification entrainera la remise à zéro des lots.",
      "de": "",
      "en": "",
      "it": ""
    }, "validate": {
      "fr": "Valider",
      "de": "",
      "en": "",
      "it": ""
    }, "warningTooManyPrize": {
      "fr": "Veuillez supprimer des lots avants d'en rajouter.",
      "de": "",
      "en": "",
      "it": ""
    }, "changeStartText": {
      "fr": "Modifier le texte de début",
      "de": "",
      "en": "",
      "it": ""
    }, "changewinningText": {
      "fr": "Modifier le texte de victoire",
      "de": "",
      "en": "",
      "it": ""
    }, "changeloosingText": {
      "fr": "Modifier le texte de défaite",
      "de": "",
      "en": "",
      "it": ""
    },
    "enterNewName": {
      "fr": "Veuillez entrer un nouveau nom",
      "de": "",
      "en": "",
      "it": ""
    }, "warningDeleteImage": {
      "fr": "Voulez vous vraiment supprimer cette image ? (Cette action est irrévocable)",
      "de": "",
      "en": "",
      "it": ""
    }, "thumbnailButton": {
      "fr": "Vignette du bouton",
      "de": "",
      "en": "",
      "it": ""
    }, "warningDeleteElement": {
      "fr": "Êtes-vous sûr de vouloir supprimer cet élément ?",
      "de": "",
      "en": "",
      "it": ""
    }, "change": {
      "fr": "Modifier",
      "de": "",
      "en": "",
      "it": ""
    }, "enterQuizName": {
      "fr": "Veuillez entrer le nom du questionnaire",
      "de": "",
      "en": "",
      "it": ""
    }, "enterLotteryName": {
      "fr": "Veuillez entrer le nom de la loterie",
      "de": "",
      "en": "",
      "it": ""
    }, "warningDeleteQuiz": {
      "fr": "Voulez-vous supprimer ce quiz ?",
      "de": "",
      "en": "",
      "it": ""
    }, "warningDeleteQuestion": {
      "fr": "Voulez-vous supprimer cette question ?",
      "de": "",
      "en": "",
      "it": ""
    }, "warningActiveQuizDelete": {
      "fr": "Impossible de supprimer le quiz actif",
      "de": "",
      "en": "",
      "it": ""
    }, "importMedia": {
      "fr": "Importer un média",
      "de": "",
      "en": "",
      "it": ""
    }, "warningDeleteMedia": {
      "fr": "Voulez-vous supprimer ce media ? (Le fichier sera supprimer du serveur)",
      "de": "",
      "en": "",
      "it": ""
    }, "warningDeleteStats": {
      "fr": "Voulez-vous supprimer ces statistiques ? (Cette opération est définitive)",
      "de": "",
      "en": "",
      "it": ""
    }, "changeWelcomeText": {
      "fr": "Modifier le texte de bienvenue",
      "de": "",
      "en": "",
      "it": ""
    }, "changeGoodbyeText": {
      "fr": "Modifier le texte de remerciement",
      "de": "",
      "en": "",
      "it": ""
    }, "loggedInAs": {
      "fr": "Vous êtes connecté en tant que",
      "de": "",
      "en": "",
      "it": ""
    }, "deco": {
      "fr": "Déconnexion",
      "de": "",
      "en": "",
      "it": ""
    }, "logout": {
      "fr": "Se déconnecter",
      "de": "",
      "en": "",
      "it": ""
    }, "enterFolderName": {
      "fr": "Veuillez entrer le nom du dossier",
      "de": "",
      "en": "",
      "it": ""
    }, "chooseImportElement": {
      "fr": "Veuillez choisir les éléments à importer",
      "de": "",
      "en": "",
      "it": ""
    }, "newFolderName": {
      "fr": "Veuillez entrer le nouveau nom du dossier",
      "de": "",
      "en": "",
      "it": ""
    }, "warningDeconnection": {
      "fr": "Etes-vous sûr de vouloir vous déconnecter ?",
      "de": "",
      "en": "",
      "it": ""
    }, "devices": {
      "fr": "Vos appareils",
      "de": "",
      "en": "",
      "it": ""
    }, "loggedOut": {
      "fr": "Vous avez bien été déconnecté",
      "de": "",
      "en": "",
      "it": ""
    }, "statistics": {
      "fr": "Statistiques",
      "de": "",
      "en": "",
      "it": ""
    }, "activateWeather": {
      "fr": "Activer la météo",
      "de": "",
      "en": "",
      "it": ""
    }, "selectCity": {
      "fr": "Selectionner la ville",
      "de": "",
      "en": "",
      "it": ""
    }, "city": {
      "fr": "Ville",
      "de": "",
      "en": "",
      "it": ""
    }, "choose": {
      "fr": "Selectionner un élément",
      "de": "",
      "en": "",
      "it": ""
    },
    "buttonSize": {
      "fr": "Taille des boutons",
      "de": "",
      "en": "",
      "it": ""
    }, "small": {
      "fr": "Petit",
      "de": "",
      "en": "",
      "it": ""
    }, "big": {
      "fr": "Grand",
      "de": "",
      "en": "",
      "it": ""
    },
    "gameConfig": {
      "fr": "Configuration du jeu",
      "de": "",
      "en": "",
      "it": ""
    },
    "soundConfig": {
      "fr": "Configuration des sons",
      "de": "",
      "en": "",
      "it": ""
    },

    "gameType": {
      "fr": "Type de jeu",

      "de": "",
      "en": "",
      "it": ""
    }, "icone": {
      "fr": "Icône",

      "de": "",
      "en": "",
      "it": ""
    }, "folder": {
      "fr": "Dossier",

      "de": "",
      "en": "",
      "it": ""
    }, "file": {
      "fr": "Fichier",

      "de": "",
      "en": "",
      "it": ""
    }, "web": {
      "fr": "Site web",

      "de": "",
      "en": "",
      "it": ""
    },
    "usermanagement": {
      "fr": "Gestion utilisateur",

      "de": "",
      "en": "",
      "it": ""
    },
    "userCreation": {
      "fr": "Créer un utilisateur",

      "de": "",
      "en": "",
      "it": ""
    },
    "updateEmail": {
      "fr": "Modifier",

      "de": "",
      "en": "",
      "it": ""
    },

    "register": {
      "fr": "Registre",

      "de": "",
      "en": "",
      "it": ""
    }, "thumbnail": {
      "fr": "Vignette",

      "de": "",
      "en": "",
      "it": ""
    }, "type": {
      "fr": "Type",

      "de": "",
      "en": "",
      "it": ""
    }, "displayName": {
      "fr": "Nom d'affichage",

      "de": "",
      "en": "",
      "it": ""
    }, "active": {
      "fr": "Actif",

      "de": "",
      "en": "",
      "it": ""
    }, "url": {
      "fr": "URL",

      "de": "",
      "en": "",
      "it": ""
    }, "thumbnailUrl": {
      "fr": "URL vignette",

      "de": "",
      "en": "",
      "it": ""
    },
    'mediaBackupSave': {
      "fr": "Créer une sauvegarde",

      "de": "",
      "en": "",
      "it": ""
    },
    'mediaBackupLoad': {
      "fr": "Charger une sauvegarde",

      "de": "",
      "en": "",
      "it": ""
    }
    ,
    'latestBackupDate': {
      "fr": "Dernière sauvegarde le",

      "de": "",
      "en": "",
      "it": ""
    },
    'confirmSaveBackupOperation': {
      "fr": "Voulez-vous enregistrer la configuration actuelle en tant que sauvegarde de secours ? (La configuration précédente sera remplacée)",

      "de": "",
      "en": "",
      "it": ""
    }, 'confirmLoadBackupOperation': {
      "fr": "Voulez-vous charger la sauvegarde de secours ? (La configuration actuelle sera perdu)",

      "de": "",
      "en": "",
      "it": ""
    },
    'assign': {
      'fr': 'Assigner à un utilisateur',

      "de": "",
      "en": "",
      "it": ""
    },
    'create': {
      'fr': 'Création',

      "de": "",
      "en": "",
      "it": ""
    },
    'update': {
      "fr": "Modification",
      "de": "",
      "en": "",
      "it": ""
    },
    'accountManagement': {
      "fr": "Gestion du compte",
      "de": "",
      "en": "",
      "it": ""
    },
    'appFile': {

      "fr": "Fichiers application",
      "de": "",
      "en": "",
      "it": ""

    },
    'displayLabel': {

      "fr": "Afficher le label des réponses",
      "de": "",
      "en": "",
      "it": ""
    }, 'enableMultipleResponse': {

      "fr": "Autoriser plusieurs réponses",
      "de": "",
      "en": "",
      "it": ""
    },

    'maxDimensionRespImage': {
      "fr": "Dimension maximale de l'image",
      "de": "",
      "en": "",
      "it": ""
    },
    'contentMediaDesign': {
      "fr": "Design contenu",
      "de": "",
      "en": "",
      "it": ""
    },
    'globalMediaDesign': {
      "fr": "Design général",
      "de": "",
      "en": "",
      "it": ""
    },
    'enableMediaHeader': {
      "fr": "Activer la barre de navigation",
      "de": "",
      "en": "",
      "it": ""
    },
    "hideItemName": {
      "fr": "Cacher les noms des éléments",
      "de": "",
      "en": "",
      "it": ""
    },
    "high": {
      "fr": "Haut",
      "de": "",
      "en": "",
      "it": ""
    },
    "center": {
      "fr": "Centre",
      "de": "",
      "en": "",
      "it": ""
    },
    "low": {
      "fr": "Bas",
      "de": "",
      "en": "",
      "it": ""
    },
    'titlePosition': {
      "fr": "Position du titre",
      "de": "",
      "en": "",
      "it": ""
    },
    'textPosition': {
      "fr": "Position du texte",
      "de": "",
      "en": "",
      "it": ""
    },
    multiKioskAvailable: {
      "fr": "Disponible avec le module \"Multi Kiosque\"",
      "de": "",
      "en": "",
      "it": ""
    },
    activateNewsBanner: {
      "fr": "Activer le bandeau",
      "de": "",
      "en": "",
      "it": ""
    },
    newsBannerTextColor: {
      "fr": "Couleur du texte de la bannière",
      "de": "",
      "en": "",
      "it": ""
    },
    newsBannerBackgroundColor: {
      "fr": "Couleur d\'arrière-plan de la bannière",
      "de": "",
      "en": "",
      "it": ""
    },
    newsBannerText: {
      "fr": "Texte de la bannière",
      "de": "",
      "en": "",
      "it": ""
    }
    ,
    changeNewsBannerText: {
      "fr": "Modifier le texte de la bannière",
      "de": "",
      "en": "",
      "it": ""
    },
    selectDeviceToBind: {
      "fr": "Selectionner la borne a assigner",
      "de": "",
      "en": "",
      "it": ""
    },
    selectedAll: {
      "fr": 'Selectionner tout',
      "de": "",
      "en": "",
      "it": ""
    },
    unselectAll: {
      "fr": 'Déselectionner tout',
      "de": "",
      "en": "",
      "it": ""
    },
    customMediaBehavior: {
      "fr": 'Comportement élément',
      "de": "",
      "en": "",
      "it": ""
    },
    pdfSettings: {
      "fr": 'Paramètres fichier pdf',
      "de": "",
      "en": "",
      "it": ""
    }
    , customMediaBehaviorPDF: {
      "fr": 'Affichage Carte - PDF Modal',
      "de": "",
      "en": "",
      "it": ""
    }, customMediaBehaviorGeneric: {
      "fr": 'Module interaction générique',
      "de": "",
      "en": "",
      "it": ""
    }, customMediaBehaviorEmail: {
      "fr": 'Envoi email',
      "de": "",
      "en": "",
      "it": ""
    }, customMediaBehaviorVideo: {
      "fr": 'Affichage carte - Video Modal',
      "de": "",
      "en": "",
      "it": ""
    },
    customMediaBehaviorXLS: {
      "fr": 'Affichage carte - XLS',
      "de": "",
      "en": "",
      "it": ""
    },

    "homeBackgroundType": {
      "fr": 'Gestion de l\'affichage de l\'écran de veille',
      "de": "",
      "en": "",
      "it": ""
    },
    "fullHomeBackground": {
      "fr": 'Plein écran',
      "de": "",
      "en": "",
      "it": ""
    },
    "splitTwothirdHomeBackground": {
      "fr": 'Scindé en 2',
      "de": "",
      "en": "",
      "it": ""
    },
    "splitThreeHomeBackground": {
      "fr": 'Scindé en 3',
      "de": "",
      "en": "",
      "it": ""
    },
    "top": {
      "fr": 'Haut',
      "de": "",
      "en": "",
      "it": ""
    },
    "middle": {
      "fr": 'Milieu',
      "de": "",
      "en": "",
      "it": ""
    },
    "bottom": {
      "fr": ' Bas',
      "de": "",
      "en": "",
      "it": ""
    },
    "svgPagePreview": {
      "fr": "Aperçu de la page",
      "de": "",
      "en": "",
      "it": ""
    },
    "interact": {
      "fr": "Interactions",
      "de": "",
      "en": "",
      "it": ""
    },
    'svgButtonExplain': {
      "fr": "Noms des calques de votre fichier SVG.",
      "de": "",
      "en": "",
      "it": ""
    },
    'assignedFile': {
      "fr": "Associer un fichier",
      "de": "",
      "en": "",
      "it": ""
    },
    'svgAssignedFileExplain': {
      "fr": "Le bouton ouvrira le fichier associé.",
      "de": "",
      "en": "",
      "it": ""
    },
    'buttons': {
      "fr": "Boutons",
      "de": "",
      "en": "",
      "it": ""
    },
    'refresh': {
      "fr": "Actualiser",
      "de": "",
      "en": "",
      "it": ""
    },
    'enableWayfinding': {
      "fr": "Activer le tracé de chemin",
      "de": "",
      "en": "",
      "it": ""
    }

  }
  constructor(public global: GlobalService) {

  }


  transform(value: string, ...args: unknown[]): unknown {
    // let key =
    //console.log(value, key[value]["it"])

    // console.log(value)
    return this.key[value][this.global.getSelectedLang()]//null//key["value"]["it"];
  }

}
